import { useMemo } from 'react'

import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'id',
  })
  let appointment = useDataValue({
    context: 'event',
    path: 'appointment',
    viewPath: props.viewPath,
  })
  return useMemo(() => {
    return {
      patient_id,
      appointment_id: appointment.id,
      booking_id: appointment.booking.id,
      tab: 'appointment_generate_letters',
    }
  }, [appointment, patient_id])
}
